// Auto generated file, do not manually modify!
// com.hotpads.rentalmanagerapi.api.web.v2.users.properties.spotlight.RentalManagerUserPropertySpotlightV2WebApiHandler

import { getClient } from '../../client';
import { httpFrontEndRequest } from '@zg-rentals/ts-client-http-client';

import type {
  ApplyListingSpotlightV2RequestDto,
  ExcludeListingSpotlightV2RequestDto,
  PinListingSpotlightV2RequestDto,
  ReassignListingSpotlightV2RequestDto,
  ReassignWithOptimizationListingSpotlightV2RequestDto,
  RemoveListingSpotlightV2RequestDto,
  UnexcludeListingSpotlightV2RequestDto,
  UnpinListingSpotlightV2RequestDto,
} from '../..';

export const RentalManagerUserPropertySpotlightV2WebApiHandler_apply_Path =
  '/api/web/v2/users/properties/spotlight/apply';

/**
 * Apply listing spotlight
 */
export const RentalManagerUserPropertySpotlightV2WebApiHandler_apply = (
  postData: ApplyListingSpotlightV2RequestDto,
  client = getClient(),
) => {
  return httpFrontEndRequest<never, ApplyListingSpotlightV2RequestDto, void>(
    {
      endpoint: RentalManagerUserPropertySpotlightV2WebApiHandler_apply_Path,
      method: 'POST',
      contextPath: '/rental-manager-api',
      postData: postData,
    },
    client,
  );
};

export const RentalManagerUserPropertySpotlightV2WebApiHandler_exclude_Path =
  '/api/web/v2/users/properties/spotlight/exclude';

/**
 * Exclude listing spotlight
 */
export const RentalManagerUserPropertySpotlightV2WebApiHandler_exclude = (
  postData: ExcludeListingSpotlightV2RequestDto,
  client = getClient(),
) => {
  return httpFrontEndRequest<never, ExcludeListingSpotlightV2RequestDto, void>(
    {
      endpoint: RentalManagerUserPropertySpotlightV2WebApiHandler_exclude_Path,
      method: 'POST',
      contextPath: '/rental-manager-api',
      postData: postData,
    },
    client,
  );
};

export const RentalManagerUserPropertySpotlightV2WebApiHandler_pin_Path = '/api/web/v2/users/properties/spotlight/pin';

/**
 * Pin listing spotlight
 */
export const RentalManagerUserPropertySpotlightV2WebApiHandler_pin = (
  postData: PinListingSpotlightV2RequestDto,
  client = getClient(),
) => {
  return httpFrontEndRequest<never, PinListingSpotlightV2RequestDto, void>(
    {
      endpoint: RentalManagerUserPropertySpotlightV2WebApiHandler_pin_Path,
      method: 'POST',
      contextPath: '/rental-manager-api',
      postData: postData,
    },
    client,
  );
};

export const RentalManagerUserPropertySpotlightV2WebApiHandler_reassign_Path =
  '/api/web/v2/users/properties/spotlight/reassign';

/**
 * Reassign listing spotlight
 */
export const RentalManagerUserPropertySpotlightV2WebApiHandler_reassign = (
  postData: ReassignListingSpotlightV2RequestDto,
  client = getClient(),
) => {
  return httpFrontEndRequest<never, ReassignListingSpotlightV2RequestDto, void>(
    {
      endpoint: RentalManagerUserPropertySpotlightV2WebApiHandler_reassign_Path,
      method: 'POST',
      contextPath: '/rental-manager-api',
      postData: postData,
    },
    client,
  );
};

export const RentalManagerUserPropertySpotlightV2WebApiHandler_reassignWithOptimization_Path =
  '/api/web/v2/users/properties/spotlight/reassignWithOptimization';

/**
 * Reassign listing spotlight with optimization
 */
export const RentalManagerUserPropertySpotlightV2WebApiHandler_reassignWithOptimization = (
  postData: ReassignWithOptimizationListingSpotlightV2RequestDto,
  client = getClient(),
) => {
  return httpFrontEndRequest<never, ReassignWithOptimizationListingSpotlightV2RequestDto, void>(
    {
      endpoint: RentalManagerUserPropertySpotlightV2WebApiHandler_reassignWithOptimization_Path,
      method: 'POST',
      contextPath: '/rental-manager-api',
      postData: postData,
    },
    client,
  );
};

export const RentalManagerUserPropertySpotlightV2WebApiHandler_remove_Path =
  '/api/web/v2/users/properties/spotlight/remove';

/**
 * Remove listing spotlight
 */
export const RentalManagerUserPropertySpotlightV2WebApiHandler_remove = (
  postData: RemoveListingSpotlightV2RequestDto,
  client = getClient(),
) => {
  return httpFrontEndRequest<never, RemoveListingSpotlightV2RequestDto, void>(
    {
      endpoint: RentalManagerUserPropertySpotlightV2WebApiHandler_remove_Path,
      method: 'POST',
      contextPath: '/rental-manager-api',
      postData: postData,
    },
    client,
  );
};

export const RentalManagerUserPropertySpotlightV2WebApiHandler_unexclude_Path =
  '/api/web/v2/users/properties/spotlight/unexclude';

/**
 * Unexclude listing spotlight
 */
export const RentalManagerUserPropertySpotlightV2WebApiHandler_unexclude = (
  postData: UnexcludeListingSpotlightV2RequestDto,
  client = getClient(),
) => {
  return httpFrontEndRequest<never, UnexcludeListingSpotlightV2RequestDto, void>(
    {
      endpoint: RentalManagerUserPropertySpotlightV2WebApiHandler_unexclude_Path,
      method: 'POST',
      contextPath: '/rental-manager-api',
      postData: postData,
    },
    client,
  );
};

export const RentalManagerUserPropertySpotlightV2WebApiHandler_unpin_Path =
  '/api/web/v2/users/properties/spotlight/unpin';

/**
 * Unpin listing spotlight
 */
export const RentalManagerUserPropertySpotlightV2WebApiHandler_unpin = (
  postData: UnpinListingSpotlightV2RequestDto,
  client = getClient(),
) => {
  return httpFrontEndRequest<never, UnpinListingSpotlightV2RequestDto, void>(
    {
      endpoint: RentalManagerUserPropertySpotlightV2WebApiHandler_unpin_Path,
      method: 'POST',
      contextPath: '/rental-manager-api',
      postData: postData,
    },
    client,
  );
};
